module.exports = __webpack_public_path__ + "static/media/university-of-houston.6be62e44.png";